import validUrlUtf8 from 'valid-url-utf8';

export default function validUrl(str, maxLength) {
  return maxLength ? str.length <= maxLength && validUrlUtf8(str) : validUrlUtf8(str);
}
